import { type CreateShareSavingsAccountForChildProcess, ProcessStatus } from '@generated-types';
import { useProcess } from '@react-query/hooks/query/use-process';
import { useTranslation } from '@translations';
import './pending-process-header.scss';

export const PendingProcessHeader = () => {
    const { data: process } = useProcess();
    const { pendingProcess } = useTranslation();

    if (!process) {
        return null;
    }

    const getHeader = (process: CreateShareSavingsAccountForChildProcess) => {
        if (process.processStatus === ProcessStatus.COMPLETED) {
            return pendingProcess.header.completed;
        }

        return pendingProcess.header.inProgress;
    };

    return <h1 className="pending-process-header">{getHeader(process)}</h1>;
};
